import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import "./staffdashboard.css";
import Dashboard from "./Dashboard";



function AdminHome() {



  return (
    <>
      <Dashboard/>
    </>
  );
}
export default AdminHome;
